var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bm-list" },
    [
      _c("list-condition", {
        attrs: { param: _vm.coSearchParameter },
        on: {
          "update:param": function($event) {
            _vm.coSearchParameter = $event
          }
        }
      }),
      _vm._v(" "),
      _c(
        "base-infinity-loading",
        {
          attrs: {
            pagination: _vm.pagination,
            "default-container": false,
            activityStatus: _vm.bmMeetings.activityStatus,
            parameter: _vm.searchParam,
            source: _vm.bmMeetingsViewModel,
            "on-fetch": _vm.storeGetBMMeetingsWithId,
            "reset-before-destroy": _vm.storeResetBMMeetings,
            "set-loader-state": _vm.setListLoaderState
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(row) {
                return [_c("list-item", { attrs: { bmMeeting: row.data } })]
              }
            }
          ])
        },
        [
          _c("template", { slot: "loader" }, [
            _c(
              "div",
              { staticClass: "ml-5 mt-3" },
              _vm._l(3, function(n) {
                return _c("bm-list-loader", { key: n })
              }),
              1
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.dtMessageErrorModel
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleCloseErrorModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.deleteModalText
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c86fff8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c86fff8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/bm-meeting-child-list/template.html
// module id = null
// module chunks = 